module.exports = __webpack_public_path__ + "assets/pointing-right-active.70fbe75b.svg";